import { ReactElement, memo, useMemo, useState } from 'react';
import * as S from './PromocodeWidget.styles';
import { useCartContext } from '@/common/app/contexts';
import { loadCookiePromocode } from '@/common/service/storage';

const PromocodeWidgetContainer = (): ReactElement => {
    const { promoStatus, promocode, promoValidation, promoRemove } = useCartContext();
    const [isOpen, setIsOpen] = useState(false);

    const promo = useMemo(() => loadCookiePromocode(), []);
    const [promoInput, setPromocode] = useState(promo || '');
    const { message, isLoading } = promoStatus;

    const isAdded = Boolean(promocode);
    const canShowStatusMsg = (message && promoInput && !isAdded) || (isAdded && isLoading);

    return (
        <S.PromoWrapper data-test-id="Promo_widget">
            {isAdded ? (
                <S.PromoTitle>
                    Promo Code&nbsp;<strong>{promocode}</strong>&nbsp;has been applied
                </S.PromoTitle>
            ) : (
                <S.PromoTitle onClick={() => setIsOpen((prev) => !prev)}>
                    Have a Promo Code? <S.Arrow isOpen={isOpen} />
                </S.PromoTitle>
            )}
            <S.Animation isOpen={isAdded || isOpen}>
                <S.PromoBottomWrapper>
                    {!isAdded && (
                        <S.PromoInput
                            placeholder="Enter Promo Code"
                            value={promoInput}
                            onChange={(e) => setPromocode(e.target.value)}
                        />
                    )}
                    {isAdded ? (
                        <S.BtnWrapper
                            variant="transparent"
                            disabled={isLoading}
                            onClick={promoRemove}
                        >
                            Remove Promo Code
                        </S.BtnWrapper>
                    ) : (
                        <S.BtnWrapper
                            variant="transparent"
                            disabled={isLoading}
                            onClick={() => promoValidation(promoInput)}
                        >
                            Apply Code
                        </S.BtnWrapper>
                    )}
                </S.PromoBottomWrapper>
                {canShowStatusMsg ? (
                    <S.StatusMsg>{message}</S.StatusMsg>
                ) : (
                    <S.Description>Promo code not required - best rate guranteed</S.Description>
                )}
            </S.Animation>
        </S.PromoWrapper>
    );
};

export const PromocodeWidget = memo(PromocodeWidgetContainer);
